import apis from './config';

const subscriberApi = apis.subscriber;

// The whole newsletter list plus its counts: { items, counts }. `search`
// filters by email substring, `onlySubscribed` drops the ones who left.
export const fetchSubscribers = async ({ search = '', onlySubscribed = false } = {}) => {
    try {
        const response = await subscriberApi.get('/', {
            params: {
                ...(search ? { search } : {}),
                ...(onlySubscribed ? { onlySubscribed: true } : {}),
            },
            headers: { Accept: 'application/json' },
        });
        const data = response.data || {};
        return {
            items: Array.isArray(data.items) ? data.items : [],
            counts: data.counts || { total: 0, subscribed: 0, unsubscribed: 0 },
        };
    } catch (error) {
        console.error('Error fetching subscribers:', error);
        throw error;
    }
};

// Take an address off the list / put it back, keeping the record and its
// signup date. Returns the updated subscriber.
export const setSubscribed = async (id, subscribed) => {
    try {
        const response = await subscriberApi.patch(
            `/${id}`,
            { subscribed },
            {
                retag: true,
                validateCsrf: true,
            },
        );
        return response.data;
    } catch (error) {
        console.error('Error updating subscriber:', error);
        throw error;
    }
};

// Erase the record for good.
export const deleteSubscriber = async (id) => {
    try {
        const response = await subscriberApi.delete(`/${id}`, {
            retag: true,
            validateCsrf: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting subscriber:', error);
        throw error;
    }
};

// Download the list as CSV. The response is a file, not JSON, so it is fetched
// as a blob and handed to the browser through a throwaway <a download>.
export const exportSubscribers = async ({ onlySubscribed = false } = {}) => {
    const response = await subscriberApi.get('/export', {
        params: onlySubscribed ? { onlySubscribed: true } : {},
        responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = `subscritores-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
